import calc from 'calculatorjs'
export function needClaim (item) {
  return false
  // 倉庫錄入的 未登記品名 下過3個訂單 就需要認領
  // return !item.desc &&
  // !item.extraInfo.tpttPic &&
  // window.vueApp.$store.state.userData.uid !== item.createdUid &&
  // window.vueApp.$store.state.order.totalCount >= 3
}

export function hideTrackingNo (trackingNo) {
  if (!trackingNo) {
    return trackingNo
  }
  // 隐藏中间4位
  const leng = (trackingNo.length - 4) / 2
  return trackingNo.replace(new RegExp(`^(.{${Math.ceil(leng)}}).{4}(.{${Math.floor(leng)}})$`), '$1****$2')
}

/**
 * 空运体积判断
 * 包裹兩邊的尺寸超過高70cm 寬85cm，單邊長不可超過300cm 例如 75*90*20 不可  60*50*320 不可
 * 210607 号更正 判斷第二大的數值是不是大於85，大於85就不能寄。如果小於85，再判斷最小數值是不是大於70，如果最小數值大於70也不能寄
 * 220715 物品單邊長度不可超過160cm
 * return true 表示有限制
 */
export function volumeLimitAir ({ length, width, height }) {
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  // if (lengthArr[0] > 85 && lengthArr[1] > 70) {
  //   return true
  // }
  // if (lengthArr[0] > 300) { // 最大边必须小于 300
  //   return true
  // }
  if (lengthArr[0] > 160) { // 物品單邊長度不可超過160cm
    return true
  }
  return false
}

/**
 * 空运G1体积判断
 */
export function airVolumeG1 ({ length, width, height }) {
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  // 三邊若兩邊超過 70cm 和 85cm
  if (lengthArr[0] > 85 && lengthArr[1] > 70) {
    return true
  }
  return false
}

/**
 * 空运G1重量判断
 */
export function airWeightG1 ({ weight }) {
  return weight > 69500
}

/**
 * 空运重量判断
 * return true 表示有限制
 */
export function weightLimitAir ({ weight }) {
  return weight > 69500
}

/**
 * 海运体积判断
 * 海快體積限制：
  寬高不可大於120*120*長（不限）
  例如 110*90*500 可以。190*120*200 不可以。
 * return true 表示有限制
 */
export function getSeShpMethod91VolumeLimitCm ({ jyAddrid, provider } = {}) {
  if (String(jyAddrid) === '1598') {
    return 120
  }
  if (provider === 'zxintz') {
    return 170
  }
  return 180
}

export function volumeLimitSe ({ length, width, height, jyAddrid }, maxWidth = 180) {
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)

  // 上海 110，其他都 180
  // if (jyAddrid === '1210' && lengthArr[1] > 110) {
  //   return true
  // } else if (jyAddrid !== '1210' && lengthArr[1] > 180) {
  //   return true
  // }
  if (lengthArr[1] >= maxWidth) {
    return true
  }

  // 深圳-三邊有兩邊超過170cm
  // 福州-三邊有兩邊超過180cm
  // 東莞-三邊有兩邊超過175cm
  // 上海倉 三邊有兩邊超過110
  // 福建倉 三邊有兩邊超過180

  // if (jyAddrid === '1024' && lengthArr[1] > 170) {
  //   return true
  // } else if (jyAddrid === '1591' && lengthArr[1] > 180) {
  //   return true
  // } else if (jyAddrid === '2769' && lengthArr[1] > 175) {
  //   return true
  // } else if (jyAddrid === '1210' && lengthArr[1] > 110) {
  //   return true
  // } else if (jyAddrid === '1050' && lengthArr[1] > 180) {
  //   return true
  // } else if (!jyAddrid && (lengthArr[1] > 120 || lengthArr[2] > 120)) {
  //   return true
  // }
  return false
}

/**
 * 海快重量判断
 * return true 表示有限制
 */
export function weightLimitSe ({ weight }) {
  return weight >= 69500
}

/**
 * 单件包裹长+宽+高>149，只能独立下单不能跟其他包裹一起打包
 * return true 表示有限制
 */
export function singleMaxVolume (item) {
  let { length, width, height, trackingNoPri } = item
  if (trackingNoPri) {
    return false // 子母单不限制
  }
  length = Number(length)
  width = Number(width)
  height = Number(height)
  // return 'UnilateralLimit'
  // if (Math.max(0, length, width, height) >= 1000) {
  //   return 'UnilateralLimit' // 單邊長超過1米的不能合并打包。只能單獨打包。
  // }
  // eslint-disable-next-line eqeqeq

  if (item.hasRawWood == 1 || item.woodenSptCov == 1 || item.woodenSpt == 1 || item.woodenBox == 1) {
    return 'hasWood' // 有木架/木箱 需要单独打包
  }
  // if (item.hctCai >= 4) {
  //   return 'hctCaiLimit' // 超才 需要单独打包
  // }
  return false
  // return (length / 10 + width / 10 + height / 10) > 149
}

export function isLongAndThin ({ length, width, height }) {
  return false // 去掉细长件限制
//   const lengthArr = [length / 10, width / 10, height / 10]
//   lengthArr.sort((a, b) => b - a)
//   // 条件1：长度大于90cm
//   // 条件2：第一大的数值/第二大的数值>9
//   return lengthArr[0] >= 90 && lengthArr[0] / lengthArr[1] > 9
}

export function isLong ({ length, width, height }) {
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  return lengthArr[0] >= 90
}

export function isSupserLong ({ length, width, height }) {
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  return lengthArr[0] >= 115
}

export function suggestTips (item) {
  if (isLongAndThin(item)) {
    return 'UnilateralLimit'
  }
  // let {length, width, height} = item
  // if (Math.max(0, length, width, height) >= 1000) {
  //   return 'UnilateralLimit' // 單邊長超過1米的。建议單獨打包。
  // }
}

/**
 * 对包裹列表以主单号进行分组
 * @param {*} _
 * @param {*} sourceList
 */
export function groupPrimaryParcelList (sourceList) {
  if (!sourceList) {
    return []
  }
  const groups = []
  sourceList.forEach(item => {
    const isQimenSent = item.extraInfo.isQimenSent && item.trackingNoPri?.endsWith('PRI')
    if (!item.trackingNoPri || isQimenSent) {
      groups.push({
        trackingNo: item.trackingNo,
        trackingNoPri: '',
        expand: true,
        parcels: [item],
      })
    } else {
      let group = groups.find(g => g.trackingNoPri === item.trackingNoPri)
      if (!group) {
        group = {
          trackingNo: item.trackingNo,
          trackingNoPri: item.trackingNoPri,
          expand: true,
          parcels: [],
        }
        groups.push(group)
      }
      group.parcels.push(item)
    }
  })
  return groups
}

/**
 * 通过长宽高计算木架、木箱費用（罗总）
 * 长m * 宽m * 高m * 1.4 （打包装的外沿）= 立方米
 * 木架 0.15 立方以下（含 0.15） 45 元/票
 * 木架 0.15 立方以上 300 元/立方
 *
 * 木箱 0.15 立方以下（含 0.15） 60 元/票
 * 木箱 0.15 立方以上 400 元/立方
 *
 * 扁平货 >长100cm >高80cm <宽30cm
 * 木架 80 元/平方
 * 木箱 120 元/平方
 *
 * @param integer $length 单位 mm
 * @param integer $width 单位 mm
 * @param integer $height 单位 mm
 * @return array [木架費用, 木箱費用, 面积体积]
 */
export function calcWoodenFeeByLuo ({ length, width, height }) {
  if (length <= 0 || width <= 0 || height <= 0) {
    return [0, 0, 0]
  }

  const $dim = [length, width, height]
  // 最长为「长」，次长为「高」，最短为「宽」（以便计算扁平货）
  $dim.sort((a, b) => b - a)

  // 计算面积、体积
  const $rate = 5
  const $area = $dim[0] * $dim[1] / 1000000
  const $volume = (length * width * height * 1.4) / 1000000000
  console.log($volume)
  const round = calc.round
  if ($dim[0] >= 1000 && $dim[1] >= 800 && $dim[2] <= 300) {
    // 扁平货
    return [round($area * 80 * $rate, 0), round($area * 120 * $rate, 0), round($area, 6)]
  } else {
    if ($volume < 0.15) {
      // 0.15 立方以下（含 0.15），木架 45 元/票，木箱 60 元/票
      return [round(45 * $rate, 0), round(60 * $rate, 0), round($area, 6)]
    } else {
      // 0.15 立方以上，木架 300 元/立方，木箱 400 元/立方
      return [round($volume * 300 * $rate, 0), round($volume * 400 * $rate, 0), round($area, 6)]
    }
  }
}

/**
 * 计算新竹 才 数
 * @param {*} param0
 * @returns
 */
export function calcHctCai ({ length, width, height }, ceil = true) {
  length = length / 10
  width = width / 10
  height = height / 10

  const lengthArr = [length, width, height]
  lengthArr.sort((a, b) => b - a)
  if (length && width && height) {
    // 扁型：最大長×最大寬÷900
    // const a = Math.ceil(lengthArr[0] * lengthArr[1] / 900)
    // // 長條型：最大長÷30
    // const b = Math.ceil(lengthArr[0] / 30)
    // 正常型：以公分丈量換算公式：才數=長度(公分)*寬度(公分)*高度(公分)/27,000[無條件進位至整數]。
    const c = length * width * height / 27000
    if (ceil) {
      return Math.ceil(c)
    }
    return c
    // return Math.max(a, b, c)
  }
  return 0
}

/**
 * 计算海运 才 数
 * @param {*} param0
 * @returns
 */
export function calcSeaCai ({ length, width, height }, ceil = true) {
  length = length / 10
  width = width / 10
  height = height / 10

  if (length && width && height) {
    const c = length * width * height / 28317
    if (ceil) {
      return Math.ceil(c)
    }
    return c
    // return Math.max(a, b, c)
  }
  return 0
}

/**
 * 棧板費用
 * 超過12才(長*寬*高/27000=才積)或重量太重無法搬運(通常50公斤以上)
 * @param {*} params
 * @returns
 */
export function hctHatPalletFee (params) {
  return params.weight >= 70000 || calcHctCai(params) >= 10
}

/**
 * 超商體積限制
 * 1. 長+寬+高≦105公分<br>
 * 2. 單邊長≦45公分、其他兩邊≦30公分<br>
 * @param {*} param0
 * @returns
 */
export function volumeLimitCs ({ length, width, height }) {
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  if (lengthArr[0] > 45 || lengthArr[1] > 30 || lengthArr[2] > 30) {
    return true
  }
  return false
}

/**
 * 超商重量限制
 * 3. 重量10公斤以內
 * @param {*} param0
 * @returns
 */
export function weightLimitCs ({ weight }) {
  return weight > 10000
}

/**
 * 黑貓體積限制
 * @param {*} param0
 * @returns
 */
export function volumeLimitTcat ({ length, width, height }) {
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  return calc(`${lengthArr[0]}+${lengthArr[1]}+${lengthArr[1]}`) > 120
}

/**
 * 大荣限制
 * @param {*} param0
 * @returns
 */
export function limitKtj (parcel, transport) {
  let { length, width, height, weight } = parcel
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  if (transport === 'air') {
    // 1.超過160公分不收
    // 2.超過40公斤不收
    // 3.奇形怪狀不收
    // ------
    // ＊有木架的也不收
    if (lengthArr[0] > 160) { // 物品單邊長度不可超過160cm
      return true
    }
    if (weight > 40000) { // 重量不可超過40公斤
      return true
    }
    if (['woodenSpt', 'woodenBox', 'woodenSptCov'].find(val => parcel[val] !== '0') ||
         parcel.extraInfo.hasRawWood > 0) {
      return true
    }
  } else {
    // 1 單件重量大於30公斤
    // 2 才積大於10才 （多少算1才）
    // 3 單邊長超過320公分
    // 4三邊長均超165公分
    if (weight > 30000) {
      return true
    }
    if (calcHctCai(parcel) > 10) {
      return true
    }
    if (lengthArr[0] > 320) {
      return true
    }
    if (lengthArr[2] > 165) {
      return true
    }
  }
  return false
}

/**
 * 新竹限制
 * @param {*} param0
 * @returns
 */
export function limitHct (parcel, transport) {
  let { length, width, height, weight } = parcel
  length = Number(length)
  width = Number(width)
  height = Number(height)
  const lengthArr = [length / 10, width / 10, height / 10]
  lengthArr.sort((a, b) => b - a)
  if (transport === 'air') {
    //  三邊總和不得超過180cm。
    return lengthArr[0] + lengthArr[1] + lengthArr[2] > 180
  } else {
  }
  return false
}

/**
 * 新竹外岛限制
 * 貨件單邊<150cm,單件<25公斤，單件<10才，
    才數計算為：長*寬*高/27000=才數，小數點無條件進位
    特殊商品才數認定：
    扁型 才數=長*寬/900
    長型 才數=長/30
 * @returns true 表示有限制
 */
export function limitHctLandAddr (parcel, transport) {
  let { length, width, height, weight } = parcel
  length = Number(length) / 10
  width = Number(width) / 10
  height = Number(height) / 10
  if (Math.max(length, width, height) >= 150) {
    return true
  }
  if (weight >= 25000) {
    return true
  }
  let cai = length * width * height / 27000
  const lengthArr = [length, width, height]
  lengthArr.sort((a, b) => b - a)
  if (lengthArr[0] > 90 && lengthArr[1] > 90 && lengthArr[2] < 10) {
    // 扁型
    cai = lengthArr[0] * lengthArr[1] / 900
  }
  if (lengthArr[0] > 90 && lengthArr[1] < 10 && lengthArr[2] < 10) {
    // 長型
    cai = lengthArr[0] / 30
  }
  if (cai >= 10) {
    return true
  }
  return false
}

/**
 * 黑貓重量限制
 * 重量20公斤以內
 * @param {*} param0
 * @returns
 */
export function weightLimitTcat ({ weight }) {
  return weight > 20000
}

/**
 * 清關件數限制﹣超過不能勾選
 * @param {*} choseList
 * @param {*} chooseItem
 * @returns
 */
export function canChooseItemCcMaxBox (choseList, chooseItem) {
  if (chooseItem.giftType) return true
  if (choseList.find(item => item.pclid === chooseItem.pclid)) return true
  return !chooseItem.extraInfo.nameList.find(nameItem => {
    let qty = 0
    let weight = Number(chooseItem.weight)
    choseList.forEach(item2 => {
      let hasSameName = false
      item2.extraInfo.nameList.forEach(nameItem2 => {
        if (nameItem2.itemCcName === nameItem.itemCcName &&
          nameItem2.itemCcMaxBox === nameItem.itemCcMaxBox &&
          nameItem2.itemCcMaxQty === nameItem.itemCcMaxQty &&
          nameItem2.itemCcMaxWt === nameItem.itemCcMaxWt
        ) {
          qty++
          hasSameName = true
        }
      })
      if (hasSameName) {
        weight += Number(item2.weight)
      }
    })
    return nameItem.itemCcMaxBox <= qty || (nameItem.itemCcMaxWt !== '999999' && Number(nameItem.itemCcMaxWt) < weight)
  })
}

export function getParcelAmount (parcel) {
  const tradeItems = parcel?.extraInfo?.tpTaobaoTradeItems
  const qimenItems = tradeItems?.filter(item => item.itemTag === 'QIMEN') || []
  if (qimenItems.length) {
    const tradeGroups = qimenItems.reduce((groups, item, index) => {
      const tradeKey = item.tradeid || item.itemTradeid || item.traTrackingNo || item.itemTrackingNo || `qimen-${index}`
      if (!groups[tradeKey]) groups[tradeKey] = []
      groups[tradeKey].push(item)
      return groups
    }, Object.create(null))

    return Object.values(tradeGroups).reduce((total, items) => {
      const hasZeroFinalPrice = items.some(item => Number(item.itemFinalPrice) === 0)
      const tradeAmountItem = hasZeroFinalPrice
        ? items.find(item => Number.isFinite(Number(item.traAmountAvg)) && Number(item.traAmountAvg) > 0)
        : null
      const tradeAmount = tradeAmountItem
        ? Number(tradeAmountItem.traAmountAvg)
        : items.reduce((prev, curr) => {
          return prev + Number(calc(`${curr.itemQty}*${curr.itemFinalPrice}`))
        }, 0)
      return calc.add(total, tradeAmount)
    }, 0)
  }
  if (tradeItems?.every(item => item.itemBrief === 'mock' || item.traStatus === 'mock')) {
    return 0
  }
  return Number(parcel?.extraInfo?.tpttAmount) || 0
}

export function getManualRegisteredAmount (parcel, tpItem) {
  const extraInfo = parcel?.extraInfo
  const tradePropItems = extraInfo?.tpTaobaoTradeItems?.filter(item => item.itemTag === 'TRADEPROP') || []
  const targetItem = tpItem || (tradePropItems.length === 1 ? tradePropItems[0] : null)
  if (!targetItem || targetItem.itemTag !== 'TRADEPROP') return null

  const rawPrice = targetItem.itemPriceQtyAvg
  const hasItemAmount = rawPrice !== null && rawPrice !== undefined && rawPrice !== ''

  if (hasItemAmount) {
    const price = Number(rawPrice)
    if (!Number.isFinite(price) || price < 0) return null

    return price
  }

  // 兼容旧的单商品数据；多商品不能用包裹金额代替商品金额。
  if (tradePropItems.length !== 1) return null

  const rawAmount = extraInfo.tpttAmount
  if (rawAmount === null || rawAmount === undefined || rawAmount === '') return null

  const amount = Number(rawAmount)
  return Number.isFinite(amount) && amount >= 0 ? amount : null
}

/**
 * 规范化工单提交时的 jyAddrid 参数
 * 三明 上海 給 巧巧郎後台客服
 * 義烏 給 漳州
 * @param {string|number} jyAddrid - 仓库地址ID
 * @returns {string|undefined} 处理后的 jyAddrid
 */
export function normalizeWorkOrderAddrid (jyAddrid) {
  jyAddrid = String(jyAddrid || '')
  if (jyAddrid === '1579') {
    // 義烏倉的工單要轉給漳州倉
    return '1596'
  }
  if (jyAddrid === '1210' || jyAddrid === '1598') {
    return undefined
  }
  return jyAddrid
}
